import { OptionType } from '@/shared/ui/select'
import * as countryFlags from 'country-flag-icons/react/3x2'
import React from 'react'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const cryptoCurrencies = ['USDT', 'TON', 'NOT', 'BTC']
export const paymentMethods = ['Telegram Stars']

export const languageToCurrency = {
  ru: ['RUB', '₽'],
  // tr: ['TRY', '₺'], no lira in rates
  kz: ['KZT', '₸'],
  pl: ['PLN', 'zł'],
  ua: ['UAH', '₴'],
  us: ['USD', '$'],
  // ir: ['IRR', '﷼'],
  id: ['IDR', 'Rp'],
  ae: ['AED', 'د.إ'],
  fr: ['EUR', '€'],
  es: ['EUR', '€'],
  vn: ['VND', '₫'],
  de: ['EUR', '€'],
  it: ['EUR', '€'],
}

export const useLocalizedDropdownOptions = (): OptionType[] => {
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.topUpSteamPage.countries

  return Object.entries(languageToCurrency).map(([key]) => ({
    value: key,
    label: texts[key as keyof typeof texts],
    img: countryFlags[key.toUpperCase() as keyof typeof countryFlags]
      ? React.createElement(countryFlags[key.toUpperCase() as keyof typeof countryFlags], {
          style: { width: '24px', height: '16px', borderRadius: '3px' },
        })
      : null,
  }))
}
